const RECAPTCHA_SITE_KEY = process.env.RECAPTCHA_SITE_KEY

let loaded = false

function loadScript () {
  if (loaded || !RECAPTCHA_SITE_KEY) return
  loaded = true
  const script = document.createElement('script')
  script.src = `https://www.google.com/recaptcha/api.js?render=${RECAPTCHA_SITE_KEY}`
  script.async = true
  document.head.appendChild(script)
}

export function initRecaptcha () {
  loadScript()
}

export function executeRecaptcha (action) {
  if (!RECAPTCHA_SITE_KEY || typeof window.grecaptcha === 'undefined') {
    return Promise.resolve(null)
  }
  return new Promise((resolve) => {
    window.grecaptcha.ready(() => {
      window.grecaptcha.execute(RECAPTCHA_SITE_KEY, { action })
        .then(resolve)
        .catch(() => resolve(null))
    })
  })
}



// WEBPACK FOOTER //
// ./src/services/recaptcha.js